import { ClaimStatusTypes } from '../../models/ClaimStatus.model'
import ScrubstrApiQueryService from '../ScrubstrApiQueryService/ScrubstrApiQueryService'

export class RejectClaimPageService {
  /**
   * Report a claimed page by id
   */
  public async rejectClaimedPage(pageId: number, isClaimed: ClaimStatusTypes, isAgency: boolean): Promise<void> {
    const scrubstrApiQueryService = new ScrubstrApiQueryService()

    await scrubstrApiQueryService.post({
      data: { isClaimed: isClaimed, isAgency: isAgency },
      endpoint: `claim-page/${pageId}`,
    })
  }
}
